"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityId = void 0;
const hex_string_1 = require("../hex-string");
/**
 * Represent Id of protocol entity (campaign, ad-set).
 */
exports.EntityId = hex_string_1.HexString;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW50aXR5LWlkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2VudGl0aWVzL2VudGl0eS1pZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFQSw4Q0FBeUM7QUFFekM7O0dBRUc7QUFDVSxRQUFBLFFBQVEsR0FBRyxzQkFBUyxDQUFBIn0=